module.exports = __webpack_public_path__ + "img/pic7.5dc19f74.png";